import React from 'react';
import { Box } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import OutlinedButton from '../../../shared/Buttons/OutlinedButton';
import FilledButton from '../../../shared/Buttons/FilledButton';

const styles = {
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
    gap: '16px',
  },
};

const DeleteRoleActionButtons = (props) => {
  const { classes, handleSubmit, handleClose } = props;

  return (
    <Box className={classes.buttonsContainer}>
      <OutlinedButton handleClick={handleClose} text="Cancel" />
      <FilledButton text="Delete" handleClick={handleSubmit} />
    </Box>
  );
};

export default withStyles(styles as any, { withTheme: true })(
  DeleteRoleActionButtons,
);
